import { ITableColumn, TableColumnTypeEnum, WidthType } from "./tableColumn.interface";

export const issuesTableColumns: ITableColumn[] = [
    {
        labelPath: "issuesPage.gridColumns.name",
        propertyKey: "name",
        colType: TableColumnTypeEnum.Text,
        width: 40,
        widthType: WidthType.Percentage,
        isSortable: true,
        sortKey: "name",
    },
    {
        labelPath: "issuesPage.gridColumns.severity",
        propertyKey: "severity",
        colType: TableColumnTypeEnum.SeverityLabel,
        width: 40,
        widthType: WidthType.Percentage,
        isSortable: true,
        sortKey: "severity",
    },
    {
        labelPath: "issuesPage.gridColumns.primaryResource",
        propertyKey: "primaryResource",
        colType: TableColumnTypeEnum.TextWithIcon,
        width: 40,
        widthType: WidthType.Percentage,
        iconSrc: "primaryResourceIcon",
        isSortable: true,
        sortKey: "primaryResource",
    },
    {
        labelPath: "issuesPage.gridColumns.ownerCreatedBy",
        propertyKey: "ownerCreatedBy",
        colType: TableColumnTypeEnum.Text,
        width: 40,
        widthType: WidthType.Percentage,
        isSortable: true,
        sortKey: "ownerCreatedBy",
    },
    {
        labelPath: "issuesPage.gridColumns.labels",
        propertyKey: "labels",
        colType: TableColumnTypeEnum.Tag,
        width: 40,
        widthType: WidthType.Percentage,
        isSortable: false,
        sortKey: "labels",
    },
    {
        labelPath: "issuesPage.gridColumns.status",
        propertyKey: "status",
        colType: TableColumnTypeEnum.StatusLabel,
        width: 40,
        widthType: WidthType.Percentage,
        isSortable: true,
        sortKey: "status",
    },
];
